import theme from '../../chart/theme';
import type { LegendComponentOption } from 'echarts';

const baseTypographyConfig = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: 12,
  lineHeight: 16,
  letterSpacing: 0.2,
  color: '#F2F5F7',
  fontVariant: ['lining-nums', 'tabular-nums'],
} as const;

const baseAxisLineConfig = {
  axisLine: { lineStyle: { color: theme.colors.axisLine } },
  axisPointer: { lineStyle: { color: theme.colors.axisPointer } },
  splitLine: { lineStyle: { color: theme.colors.splitLine } },
} as const;

export const chartDefaults = {
  grid: {
    left: '16px',
    right: '16px',
    top: '10px',
    bottom: '38px',
    containLabel: true,
  },

  legend: {
    show: true,
    top: 'bottom',
    inactiveColor: 'rgba(255, 255, 255, 0.35)',
    icon: 'circle',
    itemWidth: 8,
    formatter: (name: any) => `{a|${name}}`,
    textStyle: {
      ...baseTypographyConfig,
      color: theme.colors.defaultLegend,
      rich: {
        a: {
          align: 'center',
        },
      },
    },
  } as LegendComponentOption,

  tooltip: {
    trigger: 'axis',
    borderRadius: 16,
    borderColor: '#003649',
    backgroundColor: '#003649',
    padding: [16, 16],
    textStyle: {
      ...baseTypographyConfig,
      color: '#EAEDF0',
    },
    opacity: 1,
    appendTo: typeof document !== 'undefined' ? document.body : undefined,
    extraCssText: `box-shadow: 0px 1px 2px 0px #00000059, 0px 2px 6px 2px #00000026; z-index: 4000;`,
  },

  xAxis: {
    ...baseAxisLineConfig,
    axisTick: { alignWithLabel: true },
    splitLine: {
      show: true,
      lineStyle: { color: theme.colors.splitLine },
    },
    boundaryGap: false,
    axisLabel: {
      ...baseTypographyConfig,
      align: 'center',
    },
  },

  yAxis: {
    ...baseAxisLineConfig,
    position: 'right',
    axisLabel: {
      ...baseTypographyConfig,
      align: 'center',
      margin: 20,
    },
    splitNumber: 5,
  },

  defaultSeriesConfig: {
    smooth: true,
    animation: false,
    triggerLineEvent: true,
    showAllSymbol: true,
  },
} as const;

export const mergeTooltipConfig = (userTooltip?: any) => ({
  ...chartDefaults.tooltip,
  valueFormatter: userTooltip?.valueFormatter || ((value?: number) => value?.toFixed(2) || ''),
  formatter: userTooltip?.formatter || undefined,
  ...userTooltip,
});

export const mergeSeriesConfig = (series: any[], defaults: any) =>
  series.map((serie) => ({ ...serie, ...defaults }));
